import * as React from "react";
const SvgVanillaX = (props) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.833 1.342 10.658.167 6 4.825 1.342.167.167 1.342 4.825 6 .167 10.658l1.175 1.175L6 7.175l4.658 4.658 1.175-1.175L7.175 6l4.658-4.658Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgVanillaX;
